import styled from "@emotion/native"
import NotificationsLogo from "../assets/onboarding-v2/notifications.svg"
import { Text } from "./Typography.tsx"
import { Spacing } from "./Spacing.tsx"
import { Dimensions, Platform } from "react-native"
import { ButtonV2 } from "./ButtonV2"

type EnableNotificationsProps = {
  header: string
  text: string
  mainButton: {
    label: string
    onPress: () => void
    testID?: string
  }
  secondButton: {
    label: string
    onPress: () => void
    testID?: string
  }
}

export function EnableNotificationsV2({
  header,
  text,
  secondButton,
  mainButton,
}: EnableNotificationsProps) {
  return (
    <Wrapper>
      <Container>
        <UpperContent>
          <NotificationsLogo width={Dimensions.get("screen").width - 40} />
          <Spacing top={52} />
          <Text type="h1" color="primary" align="center">
            {header}
          </Text>
          <Spacing top={12} />
          <Text
            fontSize={20}
            lineHeight={32}
            color="gray900"
            fontFamily="IBMPlexSans-Regular"
            align="center"
          >
            {text}
          </Text>
        </UpperContent>
        <ButtonsContainer testID="notificationsButtonsContainer">
          <ButtonV2
            title={mainButton.label}
            variant="blue2"
            onPress={mainButton.onPress}
            testID={mainButton.testID}
            accessibilityLabel={mainButton.label}
          />
          <Spacing top={16} />
          <ButtonV2
            title={secondButton.label}
            onPress={secondButton.onPress}
            variant="zumthor"
            testID={secondButton.testID}
            accessibilityLabel={secondButton.label}
          />
        </ButtonsContainer>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.View`
  flex: 1;
`

const Container = styled.View`
  flex: 1;
  justify-content: space-between;
`

const UpperContent = styled.View``

const ButtonsContainer = styled.View`
  padding-bottom: ${() => (Platform.OS === "web" ? "20px" : 0)};
`
